import React from "react";
import ShopForgotPassword from "../../components/Shop/ShopForgotPassword";

const ShopForgotPasswordPage = () => {
  return (
    <div>
      <ShopForgotPassword />
    </div>
  );
};

export default ShopForgotPasswordPage;
